import React from "react";
import { Search } from "lucide-react";
import InputText from "./InputText";

/**
 * Search field matching app form styling: label + soft gray bar + leading search icon.
 */
const SearchInput = React.forwardRef(
  (
    {
      /** Omit or pass `null` for toolbar / table inline search (no label row). */
      label,
      startAdornment,
      fieldHeight,
      placeholder,
      ...props
    },
    ref
  ) => (
    <InputText
      ref={ref}
      label={label}
      placeholder={placeholder ?? "Search..."}
      fieldHeight={fieldHeight}
      startAdornment={
        startAdornment ?? (
          <Search size={18} strokeWidth={2} aria-hidden />
        )
      }
      {...props}
    />
  )
);

export default SearchInput;
